<template>
  <a
    class="scroll-down"
    v-scroll-to="{
      el: bottom ? '#start-view' : '#one-page-down',
      duration: 500,
      easing: 'linear'
    }"
  >
    {{bottom ? 'Scroll up' : 'Scroll down'}}<br>
    <i
      class="fa"
      :class="{'fa-caret-down': !bottom, 'fa-caret-up': bottom }"
    ></i>
  </a>
</template>

<script>
export default {
  name: 'ScrollDown',
  data () {
    return {
      page: {}
    }
  },
  mounted () {
    // document.onkeydown = (e) => {
    //   e = e || window.event
    //   if (e.keyCode == '40') {
    //     this.$scrollTo('#one-page-down', 600)
    //   }
    // }
  },
  props: {
    bottom: Boolean
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .scroll-down {
    position: fixed;
    bottom: 0px;
    z-index: 990;
    left: 50%;
    width: 200px;
    margin-left: -100px;
    color: #ffff76;
    font-size: 0.76rem;
    line-height: 0px;
    cursor: pointer;
    transition: all 0.2s ease;
    &:hover {
      background-color: transparent;
      transform: translateY(3px);
    }
    i {
      display: inline-block;
      font-size: 40px;
      margin-top: -5px;
    }
  }
</style>
